import generateUniqueId from 'helpers/generateUniqueId'


export const isSessionValid = (prevTimestamp) => {
    const sessionTimeLimit = 1000 * 60 * 30
    const nextTimeStamp = Date.now()

    return prevTimestamp
        && (prevTimestamp + sessionTimeLimit) > nextTimeStamp
}

export default (prevSession = {}) => {
    const nextTimeStamp = Date.now()

    if (isSessionValid(prevSession.timeStamp)) {
        return {
            ...prevSession,
            timeStamp: nextTimeStamp
        }
    }

    return {
        id: generateUniqueId(),
        timeStamp: nextTimeStamp
    }
}
